import { computed } from "vue";
import { useRoute } from "vue-router";

import { ROUTE_INBOX } from "@/router/routes";

export const useInbox = () => {
  const route = useRoute();
  const inboxAllActivityActive = computed(
    () => route.name === ROUTE_INBOX && !Object.values(route.query).length
  );
  return {
    inboxAllActivityActive,
  };
};
